import { $logger } from '@/lib/logger';

export const logFPTIWhenDomesticTransactionBlocked = country => {
  $logger.fpti(`${country}_domestic_transaction_blocked`, {
    int_error_desc: `Domestic transaction blocked in ${country}`,
    state_name: 'billing',
    transition_name: 'process_billing_error',
  });
};
